module.exports = __webpack_public_path__ + "img/wechatLogin.db6293c6.png";